export default __webpack_public_path__ + "static/media/smartphone.363ec3d8.svg";